/** 
 * @file        webpack-native-bridge.js
 *              Glue logic, polyfills, etc that allow us to write code which can be
 *              webpacked for a 'web' target without breaking necessary NodeJS functionality
 *              when run under NodeJS
 * 
 * @note        When using requireNative, relative module paths should be avoid, because they
 *              will be relative to the dcp-client bundle when loaded via dcp-client, but relative
 *              to this file when loaded via NodeJS.
 *
 * @note        requireNative() must be invoked at least once before invoking properties of requireNative,
 *              except requireNative.resolve().  Invoking it with `true` will cause it to initialize its
 *              internal datastructures without actually requiring anything.
 *
 * @author      Wes Garland, wes@kingsds.network
 * @date        Aug 2019
 */
'use strict';

const { hasNativeRequire } = require('dcp/common/dcp-env-capabilities')
const dcpEnv = require('dcp/common/dcp-env');

exports.requireNative = function webpackNativeBridge$$requireNative() {
  /* hide deps from WebPack, fall through to Node or BravoJS */
  if (!hasNativeRequire) throw new Error(`There is no native require() on this platform (${dcpEnv.platform})`)
  exports.requireNative = eval('require');

  if (arguments[0] !== true)
    return exports.requireNative.apply(this, arguments)
}

exports.requireNative.resolve = function webpackNativeBridge$$requireNative$resolve() {
  exports.requireNative(true);
  return exports.requireNative.resolve.apply(this, arguments);
}

const fakeModules = {
  process: { env: [] },
  fs: {},
  child_process: {}
}

Object.keys(fakeModules).forEach(function webpackNativeBridge$$export(moduleName) {
  try {
    exports[moduleName] = exports.requireNative(moduleName)     /* Node or BravoJS or other CommonJS environment: use underlying require */
  } catch(e) {
    exports[moduleName] = fakeModules[moduleName]       /* Webpack, but a module we have told webpack not to provide */
  }
})

/**
 * Try to wire up requireNative to try our scopes for packages before generic package names.
 * Some slight of hand to try and figure out the module handle in webpack vs webpack+ctx vs node native.
 */
function initScope()
{
  if (process && process.release?.name === 'node') /* @todo we do not have access to the exports of require('dcp/common/dcp-env') at this point to check if we are 
                                                      in node. Is there a better guard to put here to protect this code from the browser env? */
  {
    const requireNative = exports.requireNative;
    var rnModule;

    if (requireNative.main?.require === requireNative)
      rnModule = requireNative.main;
    else if (requireNative === require)
      rnModule = module;
    else
      rnModule = requireNative.cache[requireNative.resolve('.')];

    if (rnModule)
    {
      const path = requireNative('path');
      rnModule.paths
        .filter(id => /node_modules/.test(id))
        .reverse()
        .forEach(id => {
          rnModule.paths.unshift(path.resolve(id, '@kingsds'));
          rnModule.paths.unshift(path.resolve(id, '@distributive'));
        });
    } 
  }
}
initScope();
